import React, { useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import MetaParentProfileEdit, {
	ParentMetaProfileEditFormValues,
} from './MetaParentProfileEdit';
import { MetaParent } from '../../../../Components/PatientProfile/PatientProfileParts/PatientProfileInformationChildren';

interface Props extends BaseModalProps {
	parent: MetaParent;
	childId: string;
	onSuccess: () => void;
}

const MetaParentProfileEditModal: React.FC<Props> = props => (
	<BaseModal
		{...props}
		title='component.patientProfileEdit.editLegalRepresentative'>
		<MetaParentProfileEdit
			parent={props.parent}
			childId={props.childId}
			onSuccess={props.onSuccess}
		/>
	</BaseModal>
);

export default MetaParentProfileEditModal;
